module.exports = __webpack_public_path__ + "static/media/Menu-13.a6418ce8.jpg";